(function () {
  'use strict';

  function initCollectionGrid(sectionEl) {
    if (!sectionEl) return;

    var wrapper = sectionEl.querySelector('.cg-wrapper');
    if (!wrapper) return;

    var gap        = sectionEl.dataset.gap        || '12';
    var gapMob     = sectionEl.dataset.gapMobile  || '10';
    var outer      = sectionEl.dataset.outer      || '20';
    var ratio      = sectionEl.dataset.ratio      || 'portrait';
    var titleColor = sectionEl.dataset.titleColor || '#111111';
    var ctaColor   = sectionEl.dataset.ctaColor   || '#888888';

    sectionEl.style.setProperty('--cg-gap', gap + 'px');
    sectionEl.style.setProperty('--cg-gap-mobile', gapMob + 'px');
    sectionEl.style.setProperty('--cg-outer', outer + 'px');
    sectionEl.style.setProperty('--cg-title-color', titleColor);
    sectionEl.style.setProperty('--cg-cta-color', ctaColor);

    sectionEl.classList.remove('cg-ratio-portrait', 'cg-ratio-square', 'cg-ratio-landscape');
    sectionEl.classList.add('cg-ratio-' + ratio);
  }

  function init() {
    document.querySelectorAll('.collection-grid-section').forEach(function (el) {
      initCollectionGrid(el);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target : e.target.parentElement;
    initCollectionGrid(sec);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();